import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faTriangleExclamation, faXmark } from '@fortawesome/pro-regular-svg-icons';

import { SessionExpiredService } from '../../../core/services/session-expired.service';

@Component({
  selector: 'app-session-expired-modal',
  standalone: true,
  imports: [FontAwesomeModule],
  templateUrl: './session-expired-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '(document:keydown.escape)': 'dismiss()' },
})
export class SessionExpiredModalComponent {
  protected readonly sessionExpired = inject(SessionExpiredService);

  protected readonly faTriangleExclamation = faTriangleExclamation;
  protected readonly faXmark = faXmark;

  protected dismiss(): void {
    this.sessionExpired.close();
  }
}
